import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import SoundChain from './SoundChain';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class JDialog extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, dialog, button1, button2, spriteSheet, type, time)
    {
        super(scene);

        this.enabled = true;

        let dark = this.scene.add.rectangle(-1 * this.scene.scale.width / 2, -1 * this.scene.scale.height / 2, this.scene.scale.width, this.scene.scale.height, 0x000000).setAlpha(0.6).setOrigin(0);
        this.add(dark);
        this.time = time;
        this.type = type;

        if (dialog)
        {
            this.dialogBitmap = ABCyaPhaser.Images.addImage(0, 0, dialog, this).setOrigin(0.5);
            this.dialogBitmap.alpha = 0;
        }

        if (spriteSheet == null)
        {
            this.button1 = ABCyaPhaser.Images.addImage(0, 0, button1, this).setOrigin(0.5);
            if (button2)
                this.button2 = ABCyaPhaser.Images.addImage(0, 0, button2, this).setOrigin(0.5);

        }
        else
        {
            this.button1 = ABCyaPhaser.Images.addImage(0, 0, button1, this, spriteSheet).setOrigin(0.5);
            if (button2)
                this.button2 = ABCyaPhaser.Images.addImage(0, 0, button2, this, spriteSheet).setOrigin(0.5);
        }

        if (type == 1)
        {
            this.textLabel1 = ABCyaPhaser.Text.addText(0, -80, 52, 0xffffff, FontKeys._odin_roundedregular, "Bonus Round", this).setOrigin(0.5);

            this.textLabel2 = ABCyaPhaser.Text.addText(0, 0, 38, 0xffffff, FontKeys._odin_roundedregular, "Pop the bubbles in numerical order.", this).setOrigin(0.5);
        }
        else if (type == 2)
        {
            this.textLabel1 = ABCyaPhaser.Text.addText(0, -80, 52, 0xffffff, FontKeys._odin_roundedregular, "Awesome", this).setOrigin(0.5);

            this.textLabel2 = ABCyaPhaser.Text.addText(0, 0, 38, 0xffffff, FontKeys._odin_roundedregular, "You did it in " + time + " seconds.", this).setOrigin(0.5);
        }
        else if (type == 3)
        {
            this.textLabel1 = ABCyaPhaser.Text.addText(0, -80, 38, 0xffffff, FontKeys._odin_roundedregular, "Pop the bubbles so the numbers drop", this).setOrigin(0.5);

            this.textLabel2 = ABCyaPhaser.Text.addText(0, 0, 38, 0xffffff, FontKeys._odin_roundedregular, "into the correct boxes below.", this).setOrigin(0.5);
        }
        else if (type == 4)
        {
            this.textLabel = ABCyaPhaser.Text.addText(0, -160, 52, 0xffffff, FontKeys._odin_roundedregular, "Super!", this).setOrigin(0.5);

            this.textLabel1 = ABCyaPhaser.Text.addText(0, -80, 38, 0xffffff, FontKeys._odin_roundedregular, "You counted to 100 by 1's", this).setOrigin(0.5);

            this.textLabel2 = ABCyaPhaser.Text.addText(0, 0, 38, 0xffffff, FontKeys._odin_roundedregular, "Your best bonus time was " + time + " seconds.", this).setOrigin(0.5);
        }

        if (this.button2 != null)
        {
            this.button2.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick2, this);
        }

        this.button1.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick1, this);
    }

    doClick1()
    {
        if (!this.enabled) { return; }

        if (this.soundFile != null)
        {
            this.soundFile.stop();
        }

        if (this.audioChain != null)
        {
            this.audioChain.stop();
        }

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

        ABCyaPhaser.Tweens.addTween(this.button1, 70, { scale: 0.8, yoyo: true }, Phaser.Math.Easing.Quadratic.Out, () => this.destroy());

        this.doAction1();
    }

    doClick2()
    {
        if (!this.enabled) { return; }

        if (this.soundFile != null)
        {
            this.soundFile.stop();
        }

        if (this.audioChain != null)
        {
            this.audioChain.stop();
        }

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

        ABCyaPhaser.Tweens.addTween(this.button2, 70, { scale: 0.8, yoyo: true }, Phaser.Math.Easing.Quadratic.Out, () => this.destroy());

        this.doAction2();
    }

    playSound()
    {
        if (this.type == 4)
        {

            if (this.time < 21)
            {
                this.audioChain = new SoundChain(this.scene, [LocalizationSoundAssetKeys._best_bonus_time_was, this.time.toString(), LocalizationSoundAssetKeys._seconds]);
                this.audioChain.play();
            } else
            {
                // no voice voice at all
            }

        }
        else if (this.type == 2)
        {

            if (this.time < 21)
            {
                this.audioChain = new SoundChain(this.scene, [LocalizationSoundAssetKeys._you_did_it_in, this.time.toString(), LocalizationSoundAssetKeys._seconds]);
                this.audioChain.play();
            } else
            {
                ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._you_did_it, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
            }
        }
    }
}